import { createActionHelpers } from 'vuex-loading';

const { startLoading, endLoading } = createActionHelpers({
    moduleName: 'loading',
});

const state = {
    searchMeta: null,
    filters: [],
};

const getters = {
    filters(state) {
        return state.filters;
    },
};

const mutations = {
    setSearchMeta(state, meta) {
        state.searchMeta = meta;
    },

    setFilters(state, filters) {
        console.log('setfilters');
        state.filters = filters;
    },
};

const actions = {
    getSearchMeta({ commit, dispatch }) {
        let route = Laroute.route(
            'franchise.report.non_fuel.sales_category.search.meta',
        );

        startLoading(dispatch, 'get-salescategorymeta');

        return axios
            .get(route)
            .then(res => {
                commit('setSearchMeta', res.data);
                endLoading(dispatch, 'get-salescategorymeta');
                return res.data;
            })
            .catch(err => {
                endLoading(dispatch, 'get-salescategorymeta');
                throw err;
            });
    },

    getSearchMetaIfNecessary({ commit, dispatch }) {
        if (!state.searchMeta) {
            return dispatch('getSearchMeta');
        }

        return Promise.resolve(state.searchMeta);
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions,
};



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/sales-category.js